const footerLinks = {
  'For Owners': [
    { label: 'List Your Villa', id: 'lead-form' },
    { label: 'Partner Benefits', id: 'why-list' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Ideal Villa Profile', id: 'ideal-villa' },
  ],
  Company: [
    { label: 'About the Concept', id: 'about' },
    { label: 'Early Partner Programme', id: 'early-partner' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact Us', id: 'lead-form' },
  ],
};

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1C1C1C] rounded-t-[32px] px-6 pt-16 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/d4587e89-22bc-4d18-b88a-aa79aeb2720e.png"
              alt="PadelVillas"
              className="h-10 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="font-inter font-light text-white/50 text-sm leading-relaxed max-w-xs mb-8">
              The Mediterranean&apos;s first curated collection of luxury villas with private padel courts. Elevating sport and travel together.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:text-[#D4845C] hover:border-[#D4845C] transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="https://linkedin.com"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:text-[#D4845C] hover:border-[#D4845C] transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-line text-sm" />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="font-inter text-xs font-medium text-white uppercase tracking-[0.15em] mb-5">
                <a href={`#${links[0].id}`}>{section}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollTo(link.id)}
                      className="whitespace-nowrap font-inter font-light text-sm text-white/50 hover:text-white transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="font-inter text-xs text-white/30">
            &copy; {new Date().getFullYear()} PadelVillas. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-inter text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="font-inter text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer">
              Terms of Service
            </a>
            <p className="font-inter text-xs text-white/20 italic">
              Made with passion for padel
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
